// extracted by mini-css-extract-plugin
export default {"input":"inputComponent_input__B8hdr"};